module.exports = __webpack_public_path__ + "img/ring_y_e_null_1@3x.85bea2d7.png";